import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Icons, IconButton } from "@curves/ui-base";
import { useMemberProfileApi } from '@apis/useMemberProfileApi';
import useShowPDF from '@util/hook/useShowPDF';
import useMessageDialog from '@util/hook/useMessageDialog';
import { CLUB_DOCUMENTS_ROUTER } from '@icoach/router/routerPath';
import { PEOPLE_TYPE } from '@icoach/constants';

const MemberHealthCareIconButton = React.memo(
    React.forwardRef((props, ref) => {
        const { className, referenceType = PEOPLE_TYPE.MEMBER, referenceID, healthDeclarationRedirectFrom, children } = props;
        const [pdfModel, setPdfModel] = useState(null);
        const history = useHistory();
        const showPDF = useShowPDF();
        const setMessageDialog = useMessageDialog();
        const { getMemberProfileHealthDeclarationApi } = useMemberProfileApi();

        const handleHeartbeatOnClick = () => {
            const { hasNewHealthDeclaration, url } = pdfModel;
            if (hasNewHealthDeclaration) {
                showPDF({
                    open: true,
                    pdfUrl: url,
                });
            } else {
                setMessageDialog({
                    open: true,
                    title: '確認要轉跳？',
                    msg: '尚無填寫健康申告書，確定要轉跳到健康申告書總覽？',
                    onAsyncConfirm: handleGoToDocHealthDeclaration,
                });
            }
        };

        const handleGoToDocHealthDeclaration = (e, onClose) => {
            onClose && onClose();
            let path = CLUB_DOCUMENTS_ROUTER.HEALTHDECLARATION.GET_CONTRACT_PATH(referenceType, referenceID, 0);

            if (healthDeclarationRedirectFrom) path = `${path}?${healthDeclarationRedirectFrom}`;

            history.push(path);
        };

        const initGetHasPDFApi = async (id) => {
            const resp = await getMemberProfileHealthDeclarationApi(id);
            if (resp) {
                setPdfModel(resp);
            }
        };

        useEffect(
            () => {
                initGetHasPDFApi(referenceID);
            },
            // eslint-disable-next-line
            [],
        );

        if (!pdfModel) {
            return null;
        }

        return (
            <IconButton className={className} color={clsx(pdfModel.hasNewHealthDeclaration ? 'error' : 'gray')} onClick={handleHeartbeatOnClick}>
                {children || <Icons.Heartbeat />}
            </IconButton>
        );
    }),
);

export default MemberHealthCareIconButton;
